<script lang="ts" setup>
/* Stores */

import { useCityStore } from '~/store/city/city'
/* Types */
import { GiftProduct } from '~/types/api/api-v3/basket'

/* Components */
import AppMeasureUnits from '@/components/App/AppMeasureUnits.vue'

const { currencySymbol } = useCityStore()

type Props = {
  gift: GiftProduct
  giftTitle: string
}

defineProps<Props>()
</script>

<template>
  <div class="gift">
    <div v-if="gift?.image" class="gift__image">
      <nuxt-img :src="gift.image" />
    </div>

    <div class="gift__titles">
      <div>
        {{ gift?.title }}
      </div>

      <div class="gift__title-gift">
        {{ giftTitle }}
        <nuxt-img
          class="gift__title-icon"
          src="/gift-active.webp"
          alt="Подарок"
          width="16"
          height="16"
        />
      </div>
    </div>

    <div class="gift__wrapper">
      <div class="gift__price">0 {{ currencySymbol }}</div>

      <app-measure-units
        class="gift__weight"
        :weight="gift.weight"
        :volume-in-liters="gift.volume_in_liters"
        :measure="gift.measure"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gift {
  display: grid;
  grid-template-areas: 'image titles price';
  grid-template-rows: 1fr;
  grid-template-columns: max-content 1fr;
  gap: 10px;

  @include media('>=tablet') {
    grid-template-columns: 120px 1fr 100px;
    gap: 0 20px;
    align-items: center;
    width: 100%;
  }

  @include media('>=desktop-mini') {
    grid-template-columns: 75px 1fr 1fr;
    gap: 0 16px;
    align-items: center;
    width: 100%;
  }

  @include media('<tablet') {
    grid-template-areas:
      'image titles'
      '. price';
  }

  &__image {
    display: flex;
    grid-area: image;
    align-items: center;

    img {
      width: 60px;
      height: 40px;
      border-radius: 10px;

      @include media('>=tablet') {
        width: 75px;
        height: auto;
      }
    }
  }

  &__titles {
    display: flex;
    flex-direction: column;
    grid-area: titles;
    font-size: 14px;
    font-weight: 600;
    color: $text-black;

    @include media('>=tablet') {
      width: 80%;
    }
  }

  &__title-gift {
    img {
      margin-left: 4px;
      transform: translateY(3px);
    }
  }

  &__wrapper {
    display: flex;
    grid-area: price;
    gap: 8px;
    align-items: center;

    @include media('>=desktop-mini') {
      display: grid;
    }
  }

  &__price {
    font-size: 14px;
    font-weight: 800;
    color: $text-black;
  }

  &__weight {
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    color: $dark-grey;
  }
}
</style>
